export default "__VITE_ASSET__BrVKELH$__"